import { render, staticRenderFns } from "./course-settings-educators.vue?vue&type=template&id=7922ff9f&"
import script from "./course-settings-educators.vue?vue&type=script&lang=ts&"
export * from "./course-settings-educators.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports